/**
 * recording slice: 녹화 상태 관리
 * wehago-conference의 redux/modules/recording 에서 리팩토링
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type RecordingStatus = 'idle' | 'pending' | 'on' | 'off';

export interface RecordingState {
  isRecording: boolean;
  sessionId: string | null;
  startTime: number | null;
  initiatorId: string | null;
  // ── 추가 필드 (공식 jitsi-meet + V1 레거시) ──
  status: RecordingStatus;
  error: string | null;
  requestUser: string | null;
  startDateTime: string | null;
}

const initialState: RecordingState = {
  isRecording: false,
  sessionId: null,
  startTime: null,
  initiatorId: null,
  status: 'idle',
  error: null,
  requestUser: null,
  startDateTime: null,
};

const recordingSlice = createSlice({
  name: 'recording',
  initialState,
  reducers: {
    setRecording(
      state,
      action: PayloadAction<{
        isRecording: boolean;
        sessionId?: string;
        initiatorId?: string;
      }>
    ) {
      state.isRecording = action.payload.isRecording;
      if (action.payload.isRecording) {
        state.sessionId = action.payload.sessionId ?? null;
        state.initiatorId = action.payload.initiatorId ?? null;
        state.startTime = Date.now();
        state.status = 'on';
        state.error = null;
      } else {
        state.sessionId = null;
        state.initiatorId = null;
        state.startTime = null;
        state.status = 'off';
        state.requestUser = null;
        state.startDateTime = null;
      }
    },

    setStatus(state, action: PayloadAction<RecordingStatus>) {
      state.status = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    setRequestUser(state, action: PayloadAction<string | null>) {
      state.requestUser = action.payload;
    },

    setStartDateTime(state, action: PayloadAction<string | null>) {
      state.startDateTime = action.payload;
    },

    reset() {
      return initialState;
    },
  },
});

export const recordingActions = recordingSlice.actions;
export default recordingSlice.reducer;
